<template>
  <div>
    <!-- 这个form-container就自适应容器 -->
    <div class="form-container">
      <!-- 表单标题 -->
      <div class="form-title">
        <div class="divider"/>
        <div class="content"> {{ formTitle }}</div>
      </div>
      <div class="info-container">
      <!-- 车架号信息 -->
      <div class="label-column">
        <span class="label">{{ vinLabel }}：</span>
        <span class="label">{{ modelLabel }}：</span>
      </div>
      <!-- 车型信息 -->
      <div class="value-column">
        <span class="value">{{ vin === DEFAULT_EMPTY ? DEFAULT_EMPTY : vin.slice(-6) }}</span>
        <span class="value">{{ model }}</span>
      </div>
      </div>
        <!-- 
          成功状态
          isSuccess&!isLoading&&resultData && Object.keys(resultData).length > 0
        -->
        <div class="success-container status-container" :style="{ backgroundColor: successColor }" v-if="isSuccess && !isLoading">
          <slot name="success-content">
            <!-- 默认内容 -->
            <div v-if="resultData && Object.keys(resultData).length > 0">
              <!-- 根据实际接口返回的数据结构展示结果 -->
             查询成功
            </div>
          </slot>
        </div>
        <!-- 
          失败状态
          !isLoading:false且
          isFail:失败了。
          resultData:false
          resultData长度<=0
        -->
        <div class="fail-container status-container" v-if="!isLoading && isFail">
          <slot name="fail-content">
            查询失败
          </slot>
        </div>
      </div>
        <!-- 加载状态 -->
    <div class="loading-wrap" v-if="isLoading">
        <img class="loading-img" :src="loadingImg" />
      </div>
  </div>
</template>

<script>
import loadingImg from '@/assets/image/loading_icon.gif'
import { DEFAULT_EMPTY } from '@/utils/constant'
export default {
  name: 'VIN',
  data() {
    return {
      loadingImg,
      DEFAULT_EMPTY
    }
  },
  props: {
    // 默认标题：正在查询状态
    // title: {
    //   type: String,
    //   default: '正在为你查询车辆OTA升级信息，请稍候'
    // },
    // 表单标题
    formTitle: {
      type: String,
      default: ''
    },
    // 车架号标签
    vinLabel: {
      type: String,
      default: ''
    },
    // 车型标签
    modelLabel: {
      type: String,
      default: ''
    },
    // 车架号值（默认为空字符串）
    vin: {
      type: String,
      default: ''
    },
    // 车型值（默认为空字符串）
    model: {
      type: String,
      default: ''
    },
    // 加载状态
    isLoading: {
      type: Boolean,
      default: true
    },
    // 成功状态
    isSuccess: {
      type: Boolean,
      default: false
    },
    // 失败状态
    isFail: {
      type: Boolean,
      default: false
    },
    // 失败消息
    failMessage: {
      type: String,
      default: '查询失败，请稍后重试'
    },
    // 查询结果数据
    resultData: {
      type: [Object,Boolean],
      default: null
    },
    // 成功容器颜色
    successColor: {
      type: String,
      default: '#52c41a'
    },
    questions: {
        type: Array,
        default: () => []
      },

  },
  methods: {

  }

}
</script>

<style lang="less">
/* 引入共享样式 */
@import "./vin-ota/shared.less";
</style>

<style scoped lang="less">
/* 容器样式 */


/* 表单容器 */
.form-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
  border: 0.5px solid rgba(233, 234, 237, 1);
  border-radius: 6px;
  .form-title {
    margin-bottom: 8px;
    display:flex;
    align-items: center;
    .divider{
      /* 矩形 8830 */
      .px2rem(width, 2);
      .px2rem(height, 12);
      .px2rem(border-radius, 12);
      background: #2290FD;
      .px2rem(margin-right, 8);
    }
    .content{
       color: rgba(26, 29, 37, 1);
      .px2rem(font-size, 12);
      font-weight: 500;
      .px2rem(line-height, 18);
      .px2rem(letter-spacing, 0);
      text-align: left;
    }
   
  }
  .info-container{
    display: flex;
    .px2rem(padding, 12);
    .px2rem(border-radius, 6);
    .px2rem(margin-bottom, 8);
    background:#F5F7FA;
    /* 通用信息行样式（车架号/车型） */
    .label-column,.value-column{
      display: flex;
      align-items: flex-start;
      flex-direction: column;
    }
    .label-column{
      .label{
        color: #5C606A;
        .px2rem(font-size, 12);
        .px2rem(line-height, 18);
        &:first-child{
          .px2rem(margin-bottom, 8);
        }
      }
    }
    .value-column{
      .value{
        color: #1A1D25;
        .px2rem(font-size, 12);
        .px2rem(line-height, 18);
        &:first-child{
          .px2rem(margin-bottom, 8);
        }
      }
    }
    // 如果是最后一个元素margin-bottom就是0
    &:last-child{
      margin-bottom: 0;
    }
  }
  .status-container{
    /* 自动布局 */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .px2rem(padding, 12);
    .px2rem(border-radius, 6);
    width: 100%;
    box-sizing: border-box;
  }
  .fail-container{
    background: rgba(232, 48, 16, 0.1);
  }
}
.loading-wrap{
  .px2rem(margin-top, 16);
  display: flex;
  align-items: center;
  background: #fff;
  .px2rem(border-radius, 6);
  .px2rem(padding-top, 0 );
  .px2rem(padding-bottom, 0 );
  .px2rem(padding-left, 12 );
  .px2rem(padding-right, 12 );
  justify-content: center;
  img{
    .px2rem(height, 6);
  }
}

.success-content {
  width: 100%;
}

.result-item {
  display: flex;
  justify-content: center;
  align-items: center;
  .px2rem(gap, 10);
  .px2rem(margin-bottom, 10);
  .px2rem(font-size, 14);
}

.result-label {
  font-weight: bold;
  color: #555;
}

.result-value {
  color: #333;
}


/* 失败状态 */
.fail-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .px2rem(gap, 20);
  width: 100%;
}
</style>
